import { message as $message } from 'antd'
import { afterSaleStatisticsAction, shopExist, getLimitCreatedDay } from '@/services/afterSale'

const AfterSalesModel = {
    namespace: 'afterSales',
    state: {
        afterSalesCounts: [],
        hasTaoxiShop: undefined,
        iframeAfterSalesPath: '',
        erpSettingLimitCreateTimeDays: null,
        erpSettingLimitCreateTimeDaysIsInit: false
    },
    effects: {
        *query({ payload }, { call, put }) {
            const values = {
                ...(payload || {})
            }
            try {
                const res = yield call(afterSaleStatisticsAction, values)

                if (res.success) {
                    if (res.data) {
                        yield put({
                            type: 'update',
                            payload: { afterSalesCounts: res.data }
                        })
                        return res.data
                    }
                } else {
                    $message.error(res.message)
                }
            } catch (e) {
                console.error('afterSaleStatisticsAction error', e)
            }
        },

        *queryErpSettingLimitCreateTimeDays(_, { call, put, select }) {

            const erpSettingLimitCreateTimeDaysIsInit = yield select(state => state.afterSales?.erpSettingLimitCreateTimeDaysIsInit)

            if (erpSettingLimitCreateTimeDaysIsInit) {
                return
            }

            try {
                const res = yield call(getLimitCreatedDay)

                if (res.success) {
                    yield put({
                        type: 'update',
                        payload: { erpSettingLimitCreateTimeDays: res.data }
                    })
                    return res.data
                } else {
                    $message.error(res.message)
                }
            } catch (e) {
                console.error('queryErpSettingLimitCreateTimeDays error', e)
            }
            yield put({
                type: 'update',
                payload: { erpSettingLimitCreateTimeDaysIsInit: true }
            })
        },

        *queryHasTaoxiShop({ payload }, { call, put, select }) {
            const values = {
                ...(payload || {})
            }
            try {
                const hasTaoxiShop = yield select(state => state.afterSales?.hasTaoxiShop)
                // 为了避免接口重复调用
                if (hasTaoxiShop === undefined) {
                    const res = yield call(shopExist, values)
                    if (res.success) {
                        yield put({
                            type: 'update',
                            payload: { hasTaoxiShop: !!res.data }
                        })
                        return res.data
                    } else {
                        $message.error(res.message)
                    }
                }
            } catch (e) {
                console.error('catchError', e)
            }
        },
        *changeTowerRouter({ payload }, { put }) {
            yield put({
                type: 'update',
                payload: { iframeAfterSalesPath: payload?.pathname }
            })
        }
    },
    reducers: {
        update(state, { payload }) {
            return {
                ...state,
                ...payload
            }
        }
    }
}

export default AfterSalesModel
